<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t("sidebar.files") }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" @click="$refs.modalFiles.show()">{{
              $t("app.new")
            }}</b-button>
          </template>
          <template v-slot:body>
            <b-row align-h="center">
              <b-col lg="3" md="6" sm="12" class="ml-auto mb-1">
                <label for="">
                  {{ $t("categories.category") }}
                  <b-form-select
                    :options="getCategoriesWraped"
                    v-model="filter.category_id"
                    value-field="id"
                    text-field="name"
                    size="sm"
                  ></b-form-select>
                </label>
              </b-col>

              <b-col md="12" class="table-responsive">
                <b-table
                  class="table mb-0 table-borderless"
                  :items="getFiles"
                  :fields="columns"
                  :per-page="100"
                  @filtered="onFiltered"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <div v-if="filesLoading">
                        <b-spinner type="grow" class="align-middle"></b-spinner>
                        <strong>{{ $t("app.loading") }}...</strong>
                      </div>
                      <span class="h5" v-else>{{ $t("app.not-found") }}</span>
                    </div>
                  </template>

                  <template v-slot:cell(custom_properties)="data">
                    <span>
                      {{
                        getCategoryFile(data.item.custom_properties.category_id)
                      }}
                    </span>
                  </template>

                  <template v-slot:cell(action)="data">
                    <b-button
                      variant=" iq-bg-info rounded"
                      class="mr-1"
                      size="sm"
                      target="_blank"
                      :href="data.item.url"
                      ><i class="ri-download-line ml-1"></i
                    ></b-button>
                    <b-button
                      @click="deleteItem(data.item.id)"
                      variant=" iq-bg-danger rounded"
                      size="sm"
                      ><i class="ri-delete-bin-line ml-1"></i
                    ></b-button>
                  </template>
                </b-table>
                <!-- <b-pagination
                  class="mt-3 float-right"
                  v-model="filter.page"
                  :total-rows="getFiles.total"
                  :per-page="getFiles.per_page"
                  first-number
                  pills
                  size="sm"
                  @change="getData"
                ></b-pagination> -->
                <p class="mt-3">
                  {{ $t("app.registers") }} {{ getFiles.to }}
                  {{ $t("app.of") }} {{ getFiles.length }}. Total
                  {{ getFiles.length }}
                </p>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <modal-form ref="modalFiles" @refresh="getData()" />
  </b-container>
</template>
<script>
import { core } from "@/config/pluginInit";
import modalForm from "./modalForm.vue";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "Files",
  components: {
    modalForm,
  },
  mounted() {
    core.index();
    this.fetchCategories({
      type: "college_files",
    });
    this.debouncedGetFiles = _.debounce(this.getData, 500);
    this.getData();
  },
  watch: {
    "filter.category_id": {
      handler() {
        this.debouncedGetFiles();
      },
    },
  },
  methods: {
    ...mapActions({
      fetchFiles: "fetchFiles",
      deleteFiles: "deleteFiles",
      fetchCategories: "fetchCategories",
    }),
    getData() {
      this.fetchFiles(this.filter);
    },
    getCategoryFile(categoryFile) {
      return (
        this.getCategories.find((item) => item.identifier == categoryFile)
          ?.name || this.$t("categories.not-category")
      );
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    deleteItem(id) {
      this.$bvModal
        .msgBoxConfirm(this.$t("app.body-confirm-delete"), {
          title: this.$t("app.title-confirm-delete"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "success rounded",
          cancelVariant: "outline-danger rounded",
          okTitle: this.$t("app.yes"),
          cancelTitle: this.$t("app.not"),
          headerClass: "text-center",
          bodyClass: "text-center text-danger",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            const resp = await this.deleteFiles(id);
            this.getData();
            core.showSnackbar("success", this.$t("app.delete-success"));
          }
        });
    },
  },
  data() {
    return {
      filter: {
        category_id: null,
      },
      totalRows: 1,
    };
  },
  computed: {
    ...mapGetters({
      getFiles: "getFiles",
      getCategories: "getCategories",
      filesLoading: "filesLoading",
    }),
    getCategoriesWraped() {
      return [
        ...this.getCategories,
        { id: null, name: this.$t("categories.all") },
      ];
    },
    columns() {
      return [
        {
          label: this.$t("files.name"),
          key: "name",
          class: "text-center",
        },
        {
          label: this.$t("categories.category"),
          key: "custom_properties",
          class: "text-center",
        },
        { label: this.$t("app.action"), key: "action", class: "text-center" },
      ];
    },
  },
};
</script>
